<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col lg="10" xl="7">
        <b-card >
          <div slot="header">PnL per Program - Step 1 Import Pola Acara dari BMS </div>
            <b-input-group>
              <b-input-group-prepend>
                <span class="pt-1 mr-2">Periode Pnl per Program </span>
              </b-input-group-prepend>
              <vue-monthly-picker
                style="width:350px;"
                v-model="frmUpload.periode"
                dateFormat="MMMM YYYY"
                :monthLabels="monthLabels" :state="!$v.frmUpload.periode.$error"
              ></vue-monthly-picker>
            </b-input-group>
            <hr>
            <b-input-group >
              <b-input-group-prepend>
                <span class="pt-1 mr-2">Excel (*.XLSX) file&nbsp;</span>
              </b-input-group-prepend>
                <!-- <b-input-group-prepend><label class="input-group-text">Choose *.XLSX file</label></b-input-group-prepend> -->
                <b-form-file
                  v-model="fileXlsx"
                  :state="Boolean(fileXlsx)"
                  placeholder="Choose a XLSX file..."
                  drop-placeholder="Drop XLSX file here..."
                ></b-form-file>
            </b-input-group>

            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                    <b-input-group-prepend ><span class="pt-2 mr-2">Excel sheet Name </span></b-input-group-prepend>
                    <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                    <b-input-group-append ><label class="input-group-text">Data staring from Row </label></b-input-group-append>
                    <b-form-input v-model="frmUpload.startRow"  type="number" :state="!$v.frmUpload.startRow.$error"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-card class="ColsDefine mb-0">
                  <strong>mendefiniskan kolom di-Excel untuk setiap atribut/info POLA ACARA</strong>
              <b-row>
                <b-col lg="4" xl="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>Kode Program</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.progkode" :plain="true" :options="kolomXls" :state="!$v.frmUpload.progkode.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Nama Program</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.prognama" :plain="true" :options="kolomXls" :state="!$v.frmUpload.prognama.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Kelompok Program</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.groupprog" :plain="true" :options="kolomXls" :state="!$v.frmUpload.groupprog.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Rating</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.spotrate" :plain="true" :options="kolomXls" :state="!$v.frmUpload.spotrate.$error"></b-form-select>                              
                    </b-input-group>
                </b-col>
                <b-col lg="4" xl="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>NewCategory</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.newscateg" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>New Department</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.newsdep" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Live/Taping(RR)</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.liveprod" :plain="true" :options="kolomXls" :state="!$v.frmUpload.liveprod.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Blocking</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.blocking" :plain="true" :options="kolomXls" :state="!$v.frmUpload.blocking.$error"></b-form-select>                              
                    </b-input-group>
                </b-col>
                <b-col lg="4" xl="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>Quantity</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.qtytayang" :plain="true" :options="kolomXls" :state="!$v.frmUpload.qtytayang.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Durasi</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.durasi" :plain="true" :options="kolomXls" :state="!$v.frmUpload.durasi.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Hari</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.hari" :plain="true" :options="kolomXls" :state="!$v.frmUpload.hari.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Jam</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.jam" :plain="true" :options="kolomXls" :state="!$v.frmUpload.jam.$error"></b-form-select>                              
                    </b-input-group>
                </b-col>
                <b-col lg="4" xl="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>Net Revenue</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.netRevenue" :plain="true" :options="kolomXls" :state="!$v.frmUpload.netRevenue.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Net Bonus</label></b-input-group-prepend>
                        <b-form-select v-model="frmUpload.netBonus" :plain="true" :options="kolomXls" :state="!$v.frmUpload.netBonus.$error"></b-form-select>                              
                    </b-input-group>
                </b-col>
              </b-row>
            </b-card>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="upload()">
                <i class="fa fa-cloud-upload"></i> Start Import/Upload
              </button>
             <b-button variant="secondary" class="mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
          </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
    .ColsDefine {
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }
    }

</style>


<script>
import VueMonthlyPicker from "vue-monthly-picker";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import crud from "../../apis/crud";
import programtv from "../../apis/programtvpnl";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  components: {VueMonthlyPicker, Loading},
  mixins: [validationMixin],
  validations: {
        frmUpload: {
            periode: { required },
            sheetName: { required },
            startRow: { required },
            progkode: { required },
            prognama: { required },
            groupprog: { required },
            liveprod: { required },
            blocking: { required },
            spotrate: { required },
            qtytayang: { required },
            durasi: { required },
            hari: { required },
            jam: { required },
            netRevenue: { required },
            netBonus: { required }
        },
  }, 
  data() {
    return {
      isLoading:false,
      monthLabels: dropdown.monthLabels,
      fileXlsx: null,
      frmUpload:{sheetName:'Sheet1', startRow:8, progkode:'A',prognama:'B',groupprog:'C', newscateg:'D',  newsdep:'E', liveprod:'F', 
            blocking:'G',spotrate:'H',qtytayang:'I',durasi:'J',hari:'K',jam:'L'},
      kolomXls:['','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
      'AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ'],
    };
  },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
  },
  // watch:{
  //   dimCol: function(newval) {
  //       this.tblData.DimVal="";
  //       this.tblData.DimValInfo="";
  //       this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
  //   },
  // },
  created: async function(){
      const [uploadConfig] = await crud.list({tablename:'upload-polacara'});
        for (var key in uploadConfig) {
            this.frmUpload[key] = uploadConfig[key];
        }

      const tglaktif = moment(new Date(), 'YYYY-MM-DD');
      // this.frmUpload.tgl1 =  tglaktif.startOf('month').format('YYYY-MM-DD');
      this.frmUpload.periode =  tglaktif.endOf('month').format('YYYY-MM-DD');

  },  
  methods: {
    upload: async function() {
      if (this.invalidFrmUpload) {
            console.log('validation : ', this.$v.frmUpload);
            console.log('frmUpload obj : ',this.frmUpload);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (this.fileXlsx) {
            this.isLoading=true;
            try {
                const response = await programtv.upload(this.fileXlsx,this.frmUpload);
                this.isLoading=false;   
                console.log(response); 
            } catch (error) {
                this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }
                }
            }
        } else {
          toastr.warn('Please select one File XLSX that want to Upload ');
        }
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({ name: "budget.pnlprogprocess"});
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.tendering')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
      //   // router.push({name:'payable.apinv'});
      //     router.push("home");
      // }
    }

  }
};
</script>
